export default __webpack_public_path__ + "static/media/Radiology.94ed82d0.svg";